// extracted by mini-css-extract-plugin
export default {"rightSide":"PageBar_rightSide__qPDNk","link":"PageBar_link__bGgbz"};